import { useQuery } from '@hooks/reactQuery';

import { getRUStatusDashboardXMLInterface } from '@api/ruStatusDashboard';

import { extractQueryParams } from '@utils/common';

import { IRUNetworkElementId } from '@interfaces/ruStatusDashboard/dto/ruStatusDashboardDTO';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { RU_DASHBOARD_INTERFACES } from '@constants/queryKeys';

interface IUseQueryRUDashboardInterfaceReturned {
	ruDashboardInterface?: string;
	isLoadingRUDashboardInterface: boolean;
}

export const useQueryRUDashboardInterface = (
	params: IRUNetworkElementId,
): IUseQueryRUDashboardInterfaceReturned => {
	const {
		data,
		isFetching,
		isLoading,
	} = useQuery({
		queryKey: [RU_DASHBOARD_INTERFACES, params],
		queryFn: extractQueryParams(getRUStatusDashboardXMLInterface),
		allowedRoles: [
			EUserRoles.smoLightUpdater,
			EUserRoles.smoLightViewer,
		],
		enabled: [!!params.ruNetworkElementId],
		...refetchOptions,
	});

	return {
		ruDashboardInterface: data,
		isLoadingRUDashboardInterface: (isLoading && !!data) || isFetching,
	};
};
